import React from 'react'
import { AsyncSelect } from './AsyncSelect'
import { baseUrl } from 'utils/axios'
import { Option } from './Select'

export const LocationSelect = ({
  onChange,
  value,
  width,
  label,
  placeholder,
  error,
  defaultSelectFirstOption = false,
}: {
  onChange: (value: Option) => void
  value?: Option | null
  width?: string
  label?: string
  placeholder?: string
  error?: string
  defaultSelectFirstOption?: boolean
}) => {
  return (
    <AsyncSelect<{ id: number; name: string }>
      width={width}
      label={label}
      optionKey='locations'
      defaultSelectFirstOption={defaultSelectFirstOption}
      placeholder={placeholder || 'All Locations'}
      nullValue={placeholder ? undefined : { label: 'All Locations', value: null }}
      loadOptions={async (search) => {
        const data = await baseUrl.get('/locations', {
          params: {
            q: search,
          },
        })
        return data.data.data.map((item) => ({
          id: item.id,
          name: item.name,
        })) as { id: number; name: string }[]
      }}
      decoder={(item) => ({
        label: item.name,
        value: item.id,
      })}
      onChange={(value) => onChange(value)}
      value={value}
      error={error}
    />
  )
}
